import React, { useState } from "react";
import { Loader } from "../global/loader";
import add from "../../images/add.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";

export const CreateTicket = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [inputData, setInputData] = useState({
    type: "",
    description: "",
    img: "",
    format: "",
  });

  const onFileChange = async (e) => {
    try {
      setLoader(true);
      if (!e.target.files) {
        return;
      }
      const formData = new FormData();
      // formData.append("image", e.target.files[0], e.target.files[0].name);
      formData.append("image", e.target.files[0]);

      const uploadRes = await api.uploadSingleImg(formData);
      // console.log(uploadRes);

      setSelectedImg(
        `${process.env.REACT_APP_S3URL}/img_${uploadRes[0]}.${uploadRes[1]}`,
      );
      setInputData({
        ...inputData,
        img: uploadRes[0],
        format: uploadRes[1],
      });
      setLoader(false);
    } catch (e) {
      alert.show("File upload failed");
      setLoader(false);
      console.log(e.message);
    }
  };

  const handleSubmit = async () => {
    try {
      setLoader(true);
      let payload = {
        userId: userStore?.users?.user?._id,
        issueType: inputData.issueType,
        description: inputData.description,
        imageTitle: inputData?.img || "",
        imageFormat: inputData?.format || "",
      };
      // console.log(payload);
      const signalResponse = await api.createTicket(payload);
      // console.log(signalResponse);
      if (signalResponse?.success) {
        alert.show("Issue Submitted, admin will respond soon.");
        setInputData({
          type: "",
          description: "",
          img: "",
          format: "",
        });
        setTimeout(() => {
          navigate("/support");
        }, 3000);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);

      alert.show(error?.message || "Something went wrong.");
      setLoader(false);
    }
  };

  return (
    <div className="createTicketPage">
      <div className="contact-widget-area ">
        <div className="contact-widget-area-inner">
          <h2 className="section-title text-center mb-45 just-sans-bold">
            Create Ticket
          </h2>
          <div className="row">
            {/* Area Chart */}
            <div className="col">
              <div className="card sortby-box br-10 border-transparent mt-3">
                <div className="card-header br-10  bg-white border-transparent py-3 contact-form">
                  {/* <div className="form-group mb-3">
                                            <input type="text" className='form-control' onChange={(e)=>setTitle(e.target.value)} placeholder='Title...' />
                                          </div> */}
                  <div className="form-group my-3 position-relative">
                    <i className="fa-solid fa-caret-down  arrowDownIco" />

                    <select
                      name="issueType"
                      id=""
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          issueType: e.target.value,
                        })
                      }
                      value={inputData?.issueType}
                      className="form-control ng-dirty ng-invalid ng-touched"
                    >
                      <option value="">Select Issue Type*</option>
                      <option value="Account Issue">Account Issue</option>
                      <option value="Payment Issue">Payment Issue</option>
                      <option value="Technical Issue">Technical Issue</option>
                      <option value="Mexc Telegram Group">
                        Mexc Telegram Group
                      </option>
                      <option value="Boflin Telegram Group">
                        Boflin Telegram Group
                      </option>
                      <option value="Welcome Paid Email Issue">
                        Welcome Paid Email Issue
                      </option>
                      <option value="OTP Issues">OTP Issues</option>
                      <option value="Forgot Password Issues">
                        Forgot Password Issues
                      </option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="form-group my-3">
                    <textarea
                      name="description"
                      className="form-control"
                      value={inputData?.description}
                      onChange={(e) =>
                        setInputData({
                          ...inputData,
                          description: e.target.value,
                        })
                      }
                      placeholder="Add Description*"
                    ></textarea>
                  </div>
                  <label>
                    Kindly upload a screenshot of the issue (Optional)
                  </label>
                  <div className="form-group mb-3 fileUpload-modal mt-1">
                    <label>
                      <input
                        name="file"
                        onChange={onFileChange}
                        accept="image/*"
                        type={"file"}
                      />
                      {selectedImg.length > 0 ? (
                        <img className="img_sel" src={selectedImg} />
                      ) : (
                        <img src={add} />
                      )}
                    </label>
                  </div>

                  <div className="sendMailBtn mt-3">
                    <button className="btn-dark" onClick={handleSubmit}>
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              {/* table */}
            </div>
          </div>
        </div>
      </div>
      {loader && <Loader />}
    </div>
  );
};
